


<script>
    
    import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Input,
  } from "sveltestrap";
</script>
<div class="page-content">
    <Container fluid>
      <!-- <Breadcrumbs title="홈" breadcrumbItem="Dashboard" /> -->
      <Row>
        <Col lg="12">
            <Card>
                <CardBody>
                    <div class="mb-4 h1 card-title"><h2>수집하는 개인정보 및 이용 목적</h2></div>
                    <p class="card-text">
                        필수 항목 : 이메일, 개인(팀) 이름, 소속<br/>
                        이용 목적 : 참가자 본인 확인, 연락 및 문의 응대, 부정 이용 방지 및 제재 등 
                    </p>
                </CardBody>
            </Card>
        </Col>
        </Row>
        <Row>
        <Col lg="12">
            <Card>
                <CardBody>
                    <div class="mb-4 h1 card-title"><h2>개인정보 보관기관</h2></div>
                    <ul>
                        <li>
                            <p class="card-text">
                                이용목적 달성 또는 회원 탈퇴시 지체없이 파기하고 있습니다.
                            </p>
                        </li>
                        <li>
                            <p class="card-text">
                                탈퇴 의사 확인: klaid@lawcompany.co.kr
                            </p>
                        </li>
                        
                    </ul>
                    
                </CardBody>
            </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
            <Card>
                <CardBody>
                    <div class="mb-4 h1 card-title"><h2>개인정보 수집 및 이용 동의를 거부할 권리</h2></div>
                            <p class="card-text">
                                이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 단, 대회 참가 및 수상을 위해서는 필수 항목에 대한 수집 및 이용에 동의하실 필요가 있습니다. 
                            </p>
                </CardBody>
            </Card>
        </Col>
      </Row>
      
    </Container>
  </div>